var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6H2V15C2 15.5523 2.44772 16 3 16H15C15.5523 16 16 15.5523 16 15V7C16 6.44772 15.5523 6 15 6H13ZM8.5 0L11.5 4H15C16.6569 4 18 5.34315 18 7V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V6V4V3C0 1.34315 1.34315 0 3 0H8.5ZM9 4L7.5 2H3C2.44772 2 2 2.44772 2 3V4H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectories);
export default __webpack_public_path__ + "static/media/directories.9c531cbf.svg";
export { ForwardRef as ReactComponent };